import React, { useState, useEffect, useCallback } from "react";
import { useController } from "react-hook-form";
import debounce from "lodash/debounce";

import { StyledInput } from "./color.style";

const Color = ({
  control,
  value,
  name,
  required,
  error,
  readOnly,
  disabled,
  shouldUnregister = false,
}) => {
  const { field } = useController({
    name,
    control,
    rules: {
      required: {
        value: required,
        message: "This field is required",
      },
      value: value,
    },
    disabled: disabled,
    shouldUnregister: shouldUnregister,
  });
  const [color, setColor] = useState(field.value || undefined);

  const updateState = useCallback(
    debounce((val) => {
      field.onChange(val);
    }, 500),
    [field],
  );

  useEffect(() => {
    updateState(color);
  }, [color, updateState]);

  return (
    <StyledInput $error={error ? 1 : 0}>
      <input
        type="color"
        {...field}
        onChange={(e) => setColor(e.target.value)}
        value={color}
        disabled={disabled}
        readOnly={readOnly}
      />
      <span className="error">{error?.message || ""}</span>
    </StyledInput>
  );
};

export default Color;
